<template>
    <div>
        <el-carousel ref="card" :initial-index="$store.state.a.backCardWordItemNum" :interval="4000" type="card" height="200px" arrow="never" @change="aaa" :loop="false" indicator-position="none" :autoplay="false">
            <el-carousel-item v-for="(item,index) in this.$store.getters.currentCardList"  :key="index"  >
                <el-container>
                    <el-header :style="{'font-size': '50px'}" :class="{active: $store.state.a.inputWordList[index]==null ? false:$store.state.a.inputWordList[index]!=item.word ? true:false}">
                        <div :style="{'display': 'flex'}">
                            <span v-show="$store.state.a.inputWordList[index]!=item.word"  :style="{'font-size': '30px'}">{{$store.state.a.inputWordList[index]}}</span>
                            <span :style="{'flex': '0.7'}" v-show="$store.state.a.wordListSwitch ?false:true">{{item.word}}</span>
                        </div>
<!--                        <span><div>{{1}}</div><div>{{item.word}}</div></span>-->

                        <el-rate
                                v-model="value"
                                :style="{'display':'flex'}"
                        >
                        </el-rate>

                    </el-header>
                    <el-main >
<!--                        <el-rate-->
<!--                                v-model="value"-->
<!--                                :style="{'margin-top': '0px','position': 'absolute'}"-->
<!--                        >-->
<!--                        </el-rate>-->
                        <el-row :gutter="20">
                            <el-col :span="8"><div class="grid-content bg-purple" v-show="$store.state.a.wordListSwitch ?false:true"> {{item.yinjie}}</div></el-col>
                            <el-col :span="8"><div class="grid-content bg-purple"> {{item.cixing}}</div></el-col>
                            <el-col :span="8"><div class="grid-content bg-purple" v-show="$store.state.a.wordListSwitch ?false:true"> {{item.yinbiao}}</div></el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24"><div class="grid-content bg-purple-dark">{{item.fanyi}}</div></el-col>
                        </el-row>
                    </el-main>
                </el-container>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
    export default {
        name: "WordCardList",
        data() {
            return {
                value: 3,
                currentCardItemIndex:0,
                currentCardItemWord:'',
                // inputWordList:[
                //     'hello',
                //     'hello1',
                // ],
            }
        },
        mounted() {
            // this.$bus.$on('newWordLoad',this.aaa);
        },
        computed:{
            isActive(){
                //return this.$route.path.indexOf(this.link)!==-1
                return this.lastInputWord!=this.lastCheckWord;
            },
        },
        methods:{

            prevword(){
                this.$refs.card.prev();
            },
            nextword(){
                this.$refs.card.next();
            },
            settword(num){
                this.$refs.card.setActiveItem(num);
            },
            aaa(index){
                // $store.state.a.inputWordList[index]!=item.word
                // alert("121");
                // alert(this.$store.getters.currentCardList[index].word);
                // this.$store.state.a.currentCardItemIndex=index;
                this.$store.commit('setCurrentCardItemIndex',index);
                this.$store.commit('setCurrentCardItemWord',this.$store.getters.currentCardList[index].word);
                // this.$store.dispatch('setCurrentCardItemWord',index);
                // this.itemIndex=index;
            },
            bbb(){
                alert("111")
            }

        }
    }
</script>

<style scoped>
    .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 200px;
        margin: 0;
    }

    .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n+1) {
        background-color: #d3dce6;
    }
    .el-header, .el-footer {
        background-color: #B3C0D1;
        color: #333;
        text-align: center;
        line-height: 60px;
    }

    .el-aside {
        background-color: #D3DCE6;
        color: #333;
        text-align: center;
        line-height: 200px;
    }

    .el-main {
        background-color: #E9EEF3;
        color: #333;
        text-align: center;
        line-height: 30px;
    }

    body > .el-container {
        margin-bottom: 40px;
        margin-top: auto;
        position: relative;
    }

    .el-container:nth-child(5) .el-aside,
    .el-container:nth-child(6) .el-aside {
        line-height: 260px;
    }

    .el-container:nth-child(7) .el-aside {
        line-height: 320px;
        font-size: 50px;
    }
    .el-row {
        margin-bottom: 20px;
    &:last-child {
         margin-bottom: 0;
     }
    }
    .el-col {
        border-radius: 4px;
    }
    .bg-purple-dark {
        background: #99a9bf;
    }
    .bg-purple {
        background: #d3dce6;
    }
    .bg-purple-light {
        background: #e5e9f2;
    }
    .grid-content {
        border-radius: 4px;
        min-height: 36px;
    }
    .row-bg {
        padding: 10px 0;
        background-color: #f9fafc;
    }
    .active{
        background-color: #d43e2e;
    }
</style>